module.exports = {
    INITIAL: 'initial',
    FINISHED: 'finished',
    FAILED: 'failed',
};
